import 'core-js/modules/es6.function.name';
import 'core-js/modules/es7.symbol.async-iterator';
import 'core-js/modules/es6.symbol';
import 'core-js/modules/web.dom.iterable';
import _classCallCheck from '/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js';
import _createClass from '/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js';
import _possibleConstructorReturn from '/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js';
import _inherits from '/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js';
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module image/imagestyle/imagestyleui
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { normalizeImageStyles } from './utils';
import '../../theme/imagestyle.css';
/**
 * The image style UI plugin.
 *
 * @extends module:core/plugin~Plugin
 */
var ImageStyleUI = /*#__PURE__*/
function (_Plugin) {
    _inherits(ImageStyleUI, _Plugin);
    function ImageStyleUI() {
        _classCallCheck(this, ImageStyleUI);
        return _possibleConstructorReturn(this, _getPrototypeOf(ImageStyleUI).apply(this, arguments));
    }
    _createClass(ImageStyleUI, [
        {
            key: 'init',
            /**
     * @inheritDoc
     */
            value: function init() {
                var editor = this.editor;
                var configuredStyles = editor.config.get('image.styles');
                var translatedStyles = translateStyles(normalizeImageStyles(configuredStyles), this.localizedDefaultStylesTitles);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for (var _iterator = translatedStyles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var style = _step.value;
                        this._createButton(style);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }    /**
     * Creates a button for each style and stores it in the editor {@link module:ui/componentfactory~ComponentFactory ComponentFactory}.
     *
     * @private
     * @param {module:image/imagestyle/imagestyleediting~ImageStyleFormat} style
     */
        },
        {
            key: '_createButton',
            value: function _createButton(style) {
                var _this = this;
                var editor = this.editor;
                var componentName = 'imageStyle:'.concat(style.name);
                editor.ui.componentFactory.add(componentName, function (locale) {
                    var command = editor.commands.get('imageStyle');
                    var view = new ButtonView(locale);
                    view.set({
                        label: style.title,
                        icon: style.icon,
                        tooltip: true,
                        isToggleable: true
                    });
                    view.bind('isEnabled').to(command, 'isEnabled');
                    view.bind('isOn').to(command, 'value', function (value) {
                        return value === style.name;
                    });
                    _this.listenTo(view, 'execute', function () {
                        return editor.execute('imageStyle', { value: style.name });
                    });
                    return view;
                });
            }
        },
        {
            key: 'localizedDefaultStylesTitles',
            /**
     * Returns the default localized style titles provided by the plugin.
     *
     * The following localized titles corresponding with
     * {@link module:image/imagestyle/utils~defaultStyles} are available:
     *
     * * `'Full size image'`,
     * * `'Side image'`,
     * * `'Left aligned image'`,
     * * `'Centered image'`,
     * * `'Right aligned image'`
     *
     * @returns {Object.<String,String>}
     */
            get: function get() {
                var t = this.editor.t;
                return {
                    'Full size image': t('Full size image'),
                    'Side image': t('Side image'),
                    'Left aligned image': t('Left aligned image'),
                    'Centered image': t('Centered image'),
                    'Right aligned image': t('Right aligned image')
                };
            }
        }
    ], [{
            key: 'pluginName',
            /**
     * @inheritDoc
     */
            get: function get() {
                return 'ImageStyleUI';
            }
        }]);
    return ImageStyleUI;
}(Plugin);
/**
 * Returns the translated `title` from the passed styles array.
 *
 * @param {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>} styles
 * @param titles
 * @returns {Array.<module:image/imagestyle/imagestyleediting~ImageStyleFormat>}
 */
export {
    ImageStyleUI as default
};
function translateStyles(styles, titles) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for (var _iterator2 = styles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var style = _step2.value;
            // Localize the titles of the styles, if a title corresponds with
            // a localized default provided by the plugin.
            if (titles[style.title]) {
                style.title = titles[style.title];
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return styles;
}